import axios from 'axios'
import { Storage } from '@ionic/storage'
const storage = new Storage()
import router from '../../router'

function getMetaContent(metaName) {
    var metas = document.getElementsByTagName('meta');
    var re = new RegExp('\\b' + metaName + '\\b', 'i');
    var i = 0;
    var mLength = metas.length;

    for (i; i < mLength; i++) {
        if (re.test(metas[i].getAttribute('name'))) {
            return metas[i].getAttribute('content');
        }
    }

    return '';
}

const appVersion = getMetaContent('version')

//console.log(appVersion)

const state = {
    user: null,
    token: null,
    appVersion
}
const mutations = {
    SET_USER (state, data) {
        storage.set('user', data)
        state.user = data
    },
    SET_TOKEN (state, data) {
        state.token = data
    },
    CLEAR_DATA (state) {
        state.user = null
        state.token = null
    }
}

const actions = {
    async initialise ({state, commit, dispatch}) {
        await storage.get('token').then(async (val) => {
            commit('SET_TOKEN', val)
            if(val) {
                await dispatch('setUser').then().catch(async (error) => {
                    await storage.get('user').then(async (val) => {
                        //console.log('user', val)
                        commit('SET_USER', val)
                    })
                    await dispatch('challenge/loadChallenge', {}, {root:true})

                })
            }
        })

        await storage.get('user').then(async (val) => {
            commit('SET_USER', val)
        })
        await dispatch('challenge/loadChallenge', {}, {root:true})
        if(state.user) {
            //setTimeout(() => {
                if(!state.user.hideScan) dispatch('data/getEvoltData', null, {root: true})
                dispatch('data/getWorkoutData', null, {root: true})
            //}, 2000)
        }
        //console.log('init complete')
    },
    async forgot ({ commit, rootState, getters }, data) {
        //console.log(data)
        if(rootState.global.offline) return
        commit('global/SET_SYNCING', 'Sending Reset Link', {root: true})
        commit('global/SET_MESSAGE', null, {root: true})

        return axios.post(rootState.settings.baseUrl + 'challenge-forgot-password',
            data,
            {
                headers: {
                    'Content-Type': 'application/json',
                    'X-Requested-With': 'XMLHttpRequest'
                }
            }).then(async response => {
                //console.log(response)
                router.push('/login')
                commit('global/SET_SYNCING', null, { root: true })
                commit('global/SET_MESSAGE', {type: 'success', message: response.data, flash: true}, { root: true })

        }).catch(error => {
            commit('global/SET_MESSAGE', {type: 'error', message: error.response.data}, { root: true })
            commit('global/SET_SYNCING', null, { root: true })
        })
    },
    async login ({ state, commit, rootState, dispatch }, data) {
        //console.log(data)
        if(rootState.global.offline) return
        commit('global/SET_SYNCING', 'Logging In', { root: true })
        commit('global/SET_MESSAGE', null, { root: true })

        return axios.post(rootState.settings.baseUrl + 'challenge-login',
            data,
            {
                headers: {
                    'Content-Type': 'application/json',
                    'X-Requested-With': 'XMLHttpRequest'
                }
            })
            .then(async response => {
                dispatch('setToken', response.data.token)
                await dispatch('setUser').then(() => {
                    router.push('/')
                })
                if(state.user) {
                    //setTimeout(() => {
                    if(!state.user.hideScan) dispatch('data/getEvoltData', null, {root: true})
                    dispatch('data/getWorkoutData', null, {root: true})
                    //}, 2000)
                }
            }).catch(error => {
                commit('global/SET_SYNCING', null, { root: true })
                console.error(error)
                switch (error.response.status) {
                    default:
                        commit('global/SET_MESSAGE', {type: 'error', message: 'Unknown Error'}, { root: true })
                        break;
                    case 401:
                        commit('global/SET_MESSAGE', {type: 'error', message: 'Invalid email or password. Please try again.'}, { root: true })
                        break;
                }
                throw error.response

            })

    },
    async logout ({ commit, rootState, dispatch }, data) {
        commit('global/SET_SYNCING', 'Logging Out', { root: true })
        storage.clear().then(() => {
            commit('global/SET_SYNCING', null, { root: true })
            location.reload()
        }).catch(error => {
            commit('global/SET_SYNCING', null, { root: true })
            throw error
        })

    },
    async setUser ({commit, state, dispatch, rootState, rootGetters}, inBackground) {
        if(rootState.global.offline) return

        if(!inBackground) commit('global/SET_SYNCING', 'Loading Data', { root: true })
        return new Promise((resolve, reject) => {
            axios.post(rootState.settings.baseUrl + 'challenge-user',
                {
                    provider: 'members',
                    app_version: appVersion,
                    userAgent: navigator.userAgent
                },
                {
                    headers: {
                        'Authorization': 'Bearer ' + state.token
                    }
                })
                .then(async function (response) {
                    if(response.data.data && response.data.data.challenge) {
                        commit('SET_USER', response.data.data)
                        await dispatch('Streams/setStreams', response.data.data.challenge.streams, { root: true })
                        if (response.data.data.stream) await dispatch('Streams/setStreamById', response.data.data.stream.id, { root: true })
                        await dispatch('challenge/setChallenge', response.data.data.challenge, { root: true })
                        //await dispatch('MealPlan/setChallenge', response.data.data.challenge, { root: true })
                        var imageType = '1'
                        if(rootGetters['challenge/currentWeek'] <= rootGetters['challenge/weeks']/2)
                            imageType = '0'

                        dispatch('data/setPhotoType', imageType, { root: true })
                        //dispatch('challenge/selectStream', response.data.data.stream, { root: true })
                        dispatch('messages/setMessages', response.data.data.challenge.messages, { root: true })

                        //dispatch('data/setEvoltData', response.data.data.evolt_data, {root: true})
                        if(!inBackground) commit('global/SET_SYNCING', null, { root: true })

                    } else {
                        //console.log('no chall')
                        var user = state.user
                        if(user) user.challenge = null
                        commit('SET_USER', user)
                        setTimeout(() => router.push('/select-challenge'), 500)
                    }

                    // schedule a new update
                    setTimeout(() => dispatch('setUser', true), rootState.settings.refresh_timeout) // every hour in the background
                    resolve(response)

                })
                .catch(function (error) {
                    if(!inBackground) commit('global/SET_SYNCING', null, { root: true })
                    //dispatch('setToken', null)
                    //router.push('login')
                    //throw error.response
                    //console.log('Get default user')

                    reject(error)

                })
        })

    },
    async setToken ({commit}, value) {
        storage.set('token', value)
        commit('SET_TOKEN', value)
    }
}

const getters = {
    isLoggedIn (state) {
        return state.token ? true : false
    },
    hasChallenge (state) {
        if (!state.user) return null
        return state.user.challenge
    },
    appVersion (state) {
        return state.appVersion
    },
    user (state) {
        return state.user
    }
}

export default {
    namespaced: true, state, mutations, actions, getters
}
